import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SectionSection from "../../../../shared/Section";
import Iframe from "../../../../shared/utilities/IFrame";

function ActiveVsInactiveMap(props) {
  const [reportName, setReportName] = useState(
    "HWTS Active vs Inactive Facilities (Map)"
  );
  document.title = reportName;

  return (
    <div>
      <SectionSection
        title={
          <Link to="/reports" style={{ color: "white" }}>
            {reportName}
          </Link>
        }
        type={"standout"}
      />
      <div className="" style={{ position: "relative", width: "100%" }}>
        <Iframe source="https://dtsc.maps.arcgis.com/apps/mapviewer/index.html?webmap=a062493e25e94139959b758525768769" />
      </div>
    </div>
  );
}

export default ActiveVsInactiveMap;
